<template>
    <b-row>
      <b-col md="12">
        <b-card v-if="!!menu">
          <div slot="header">
            <b-row>
              <b-col lg="8">
                <strong>Menu {{menu.id}} Information</strong> 
              </b-col>
              <b-col lg="4">
                <b-button style="margin-right:10px;" ref="printBtn" type="button" size="md" variant="primary" @click="print()">Print</b-button>  
                <b-button ref="emailBtn" type="button" size="md" variant="primary" @click="email(menu)">Email To Client</b-button>  
              </b-col>
            </b-row>
          </div>

  
          <b-form  id="menu" >
              <b-form-group
                :label='$t("menu.menu_id")'
                label-for="identification"
                :label-cols="3"
                >                
                <label plaintext redonly id="identification" type="text" :value="menu.id"></label>
              </b-form-group>

              <b-form-group
                :label='$t("menu.client")'
                label-for="client"
                :label-cols="3"
                >
                <b-form-input plaintext redonly id="client" type="text" :value="client.first_name+' '+ client.last_name"></b-form-input>
              </b-form-group> 

              <b-form-group
                :label='$t("menu.problems")'
                label-for="problems"
                :label-cols="3"
                >
                <b-form-input plaintext redonly id="problems" type="text" :value="menu.problems"></b-form-input>
              </b-form-group>

              <b-form-group
                :label='$t("menu.stats")'
                label-for="stats"
                :label-cols="3"
                >
                <b-form-input plaintext redonly id="stats" type="text" :value="menu.stats"></b-form-input>
              </b-form-group>

              <b-form-group
                :label='$t("menu.source")'
                label-for="source"
                :label-cols="3"
                >
                <b-form-input plaintext redonly id="source" type="text" :value="menu.source"></b-form-input>
              </b-form-group>

              <div class="meal-container">
                <!-- <strong>Meals</strong> 
                <div >
                  <strong>Meal Type</strong> {{ meal.meal_type_name }} <br> 
                  <strong>Foods</strong> <br>
                  <div class="row" v-for="food in meal.foods">
                  <strong>Quantity Min</strong> {{ food.quantity_min }} <br> 
                  <strong>Total Gram</strong> {{ food.total_gram }} <br> 
                    <div col="6"> Food : {{food.food.name}}</div>
                    <div col="6"> Food Hebrew:  {{food.food.hebrew_name}}</div>
                    <div col="6"> Serving Size : {{food.food.serving_size}}</div>
                    <div col="6"> Serving Weight : {{food.food.serving_weight}}</div>
                  </div>
                </div>
                 -->

                 
                <b-row v-if="menu.meals.length > 0" v-for="(meal,i) in menu.meals">
                  <b-col lg="12" style="margin-bottom:10px;">
                    <strong>{{ $t('menu.meal') }} #{{i+1}} {{ meal.meal_type_name }} </strong><br> 
                    <b-row>
                      <b-col lg="12">
                        <!-- <strong>Foods : </strong> -->
                        <b-row v-for="(food, index) in meal.foods"  style="margin-bottom:5px;">
                          <b-col lg="6" md="4"> <b>{{index+1}}.</b> {{food.food.name}}  |  {{food.food.hebrew_name}}</b-col>
                          <b-col lg="2" md="3"> <b>{{ $t('menu.serving_size') }} :</b>   {{food.food.serving_size}}</b-col>
                          <b-col lg="2" md="3"> <b>{{ $t('menu.serving_weight') }} :</b>  {{food.food.serving_weight}}</b-col>
                          <!-- <b-col lg="2"> <b>Qty :</b>  {{food.quantity_min}}</b-col> -->
                        </b-row> 
                      </b-col>
                    </b-row> 
                  </b-col>
                </b-row>
                <div v-if="menu.meals.length == 0">
                {{ $t('menu.no_meals') }}
                </div>
              </div>

          </b-form>
        </b-card>
        <!--
        <b-card  >
          <div slot="header">
            <b-row>
              <b-col lg="8">
              <strong>{{ $t('menu.created_menu') }} {{created.id}} {{ $t('menu.info') }}</strong> 
              </b-col>
              <b-col lg="4">
                <b-button style="margin-right:10px;" ref="printBtn" type="button" size="md" variant="primary" @click="print()">{{ $t('menu.print') }}</b-button>  
                <b-button ref="emailBtn" type="button" size="md" variant="primary" @click="email(created)">{{ $t('menu.email_to_client') }}</b-button>  
              </b-col>
            </b-row>
          </div>
          -->

        <div v-if="!!created" data-role="header" class="border-bottom ui-bar-a ui-header" role="banner">
          <h1 class="logoimg ui-title" tabindex="0" role="heading" aria-level="1"><a href="javascript:;" rel="external" class="ui-link"><img src="images/menulogo.jpg" alt="menu"></a></h1>
        </div>
        <div data-role="page" id="home" v-if="!!created">
          <div data-role="content" class="text-page ui-content">
              <div data-role="content" class="text-page ui-content" role="main">
                <div v-if="created.meals.length > 0" v-for="(meal,i) in created.meals" data-role="collapsible" data-theme="c" data-content-theme="d" data-inset="false" data-collapsed-icon="arrow-r" data-expanded-icon="arrow-d" data-corners="false" data-collapsed="true" class="ui-collapsible-contain">
                    <h4 v-b-toggle="'collapse'+i" class="ui-collapsible-heading ui-collapsible-heading-collapsed">
                    <a href="javascript:;" style="text-decoration:none;" class="ui-collapsible-heading-toggle ui-btn ui-btn-icon-left ui-shadow ui-corner-all ui-btn-up-c" data-theme="c">
                    <span class="ui-btn-inner ui-corner-all"><span class="ui-btn-text">{{meal.type}}<span class="ui-collapsible-heading-status"> click to expand contents</span></span>
                    <span data-theme="d" class="ui-btn ui-btn-up-d ui-btn-icon-left ui-btn-corner-all ui-shadow"><span class="ui-btn-inner ui-btn-corner-all ui-corner-all">
                    <span class="ui-btn-text"></span><span class="ui-icon ui-icon-shadow ui-icon-plus"></span></span></span></span></a></h4>
                    
                    <b-collapse :id="'collapse'+i" class="mt-2">
                      <div class="ui-collapsible-content ui-collapsible-content" aria-hidden="true">
                        <b-row>
                          <b-col lg="12" style="margin-bottom:10px;">
                          <b-row>
                            <b-col lg="4"  md="7"> <strong>{{ $t('menu.meal') }} #{{i+1}} {{ meal.type }}</strong></b-col> 
                            <b-col lg="8"  md="5"> <b>{{ $t('menu.energy') }} : </b> <span> {{ meal.foods | totalCal }}</span></b-col> 
                          </b-row> 
                          <b-row>
                            <b-col lg="12">
                              <b-row v-for="(food, index) in meal.foods"  style="margin-bottom:5px;">                                    
                                <b-col lg="8"  md="5"> <b>{{ $t('menu.qty') }} : </b> {{food.qty}} ,  <b>{{ $t('menu.energy') }} : </b> {{food.energy_kc}} , <b>{{ $t('menu.serving') }} : </b>{{food.servingVal}} {{food.serving}}</b-col> 
                                <b-col lg="4"  md="7"> <b>{{i+1}}.</b> {{food.english_title}}  |  {{food.hebrew_title}} </b-col> 
                              </b-row> 
                            </b-col>
                          </b-row> 
                          </b-col>
                        </b-row> 
                      </div>
                    </b-collapse>
                </div>
              </div>
          </div>
        </div>

        <div  v-if="!!created" class="ui-collapsible-content" aria-hidden="false">
          <ul data-role="listview" data-theme="d" class="ui-listview">
              <li class="ui-li-has-icon ui-btn ui-btn-icon-right ui-li ui-btn-hover-d" data-theme="d"><div class="ui-btn-inner ui-li"><div class="ui-btn-text">
              <a href="javascript:;" @click="email(created)" data-rel="dialog" rel="external" class="ui-link-inherit"><img src="images/b-email.png" class="ui-li-icon ui-corner-none ui-li-thumb"> VIA EMAIL</a>
          </div><span class="ui-icon ui-icon-arrow-r"></span></div></li>
          </ul>
        </div>


         <!-- 
          <b-form  id="menu" >
              <b-form-group
                :label='$t("menu.menu_id")'
                label-for="identification"
                :label-cols="3"
                >                
                <label plaintext redonly id="identification" type="text" :value="created.id">{{created.id}}</label>
              </b-form-group>

              <b-form-group
                :label='$t("menu.client")'
                label-for="client"
                :label-cols="3"
                >
                <b-form-input plaintext redonly id="client" type="text" :value="client.first_name+' '+ client.last_name"></b-form-input>
              </b-form-group>

              <div class="meal-container">
                <strong>{{ $t('menu.foods') }} </strong><br> 
                <b-row v-if="created.meals.length > 0" v-for="(meal,i) in created.meals">
                  <b-col lg="12" style="margin-bottom:10px;">
                    <b-row>
                      <b-col lg="4"  md="7"> <strong>{{ $t('menu.meal') }} #{{i+1}} {{ meal.type }}</strong></b-col> 
                      <b-col lg="8"  md="5"> <b>{{ $t('menu.energy') }} : </b> <span> {{ meal.foods | totalCal }}</span></b-col> 
                    </b-row> 
                    <b-row>
                      <b-col lg="12">
                        <b-row v-for="(food, index) in meal.foods"  style="margin-bottom:5px;">
                          <b-col lg="4"  md="7"> <b>{{i+1}}.</b> {{food.english_title}}  |  {{food.hebrew_title}} </b-col> 
                          <b-col lg="8"  md="5"> <b>{{ $t('menu.qty') }} : </b> {{food.qty}} ,  <b>{{ $t('menu.energy') }} : </b> {{food.energy_kc}} , <b>{{ $t('menu.serving') }} : </b>{{food.servingVal}} {{food.serving}}</b-col> 
                        </b-row> 
                      </b-col>
                    </b-row> 
                  </b-col>
                </b-row>
                <div v-if="created.meals.length == 0">
                  {{ $t('menu.no_meals') }}
                </div>
              </div>
        -->
          </b-form>
          <!--
        </b-card>
        -->
      </b-col>
    </b-row>
</template>

<script>

import { required } from 'vuelidate/lib/validators';
import ProfileService from '@/services/profile.service.js';
import DataMenuService from '@/services/datamenu.service.js';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import Nutritionist from '@/store/ORM/nutritionists.js';
import Client from '@/store/ORM/client.js';

export default {
  name: 'MenuInfo',
  props: {
    menu : Object,
    created: Object,
  },
  data() {
    return {
      isLoading: false,
      client : null
    }
  },
  methods : {
    print(){
      this.$refs.printBtn.style.display = 'none';
      window.print();
      this.$refs.printBtn.style.display = 'inline-block';
      // console.log(document);
      // var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      // mywindow.document.write('<html><head><title>' + document.title  + '</title>');
      // mywindow.document.write('</head><body >');
      // mywindow.document.write(document.getElementById("menu").innerHTML);
      // mywindow.document.write('</body></html>');

      // mywindow.document.close(); // necessary for IE >= 10
      // mywindow.focus(); // necessary for IE >= 10*/

      // mywindow.print();
      // mywindow.close();


    },
    email(menu){
      var vm = this;
      var i18n = this.$i18n;
      DataMenuService.email({menu:menu,client:this.client}).then((res)=>{
        vm.$toastr.success(i18n.t('menu.menu_emailed_success'),i18n.t('menu.menu_emailed_success'));
      });
    }
  },
  created(){
    // if(!!this.menu){
    //   this.client = Client.query().whereId(parseInt(this.menu.client)).first();
    // }else{
    //   this.client = Client.query().whereId(parseInt(this.created.client_id)).first();
    // }
      console.log(this.created);

  },
  filters:{
    totalCal : function(foods){
      let total = 0;

      foods.forEach((food)=>{
        if(!!food.energy_kc){
          total += food.energy_kc;
        }
      });

      return total;

    }
  }

}
</script>

<style>
  input:read-only:focus {
    outline-offset: 0px !important;
    outline: 0px !important;
  }
  .col{
    display:flex;
    align-items: center;
  }

  .ui-header,#home-footer,.ui-collapsible-content{
    margin: 0px 15px;
  }


  .ui-btn-up-c {
    font-family: 'Open Sans', sans-serif;
    border: 1px solid #111;
    background: #669933;
    font-weight: bold;
    color: #000;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#669933), to(#a7c118));
    background-image: linear-gradient(#669933 , #a7c118);
}
    div.gallery-row:after { clear: both; content: "."; display: block; height: 0; visibility: hidden; }
    div.gallery-item {
  float: left;
  width: 50%;
}
    div.gallery-item a { display: block; margin: 5px; border: 1px solid #3c3c3c; }
    div.gallery-item img { display: block; width: 100%; height: auto; }
    #Gallery1 .ui-content, #Gallery2 .ui-content { overflow: hidden; }
</style>

  